import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { OutlinedButton, InfoWidget } from '@ds/react-components';
import { Typography, Grid } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import { numberToCurrency } from 'utils/misc';
import UpcomingPaymentsLoader from './UpcomingPaymentsLoader';

const styles = (theme) => ({
  root: {},
  dateText: {
    color: theme.palette.xpl.text.secondary,
    fontSize: '14px',
    fontWeight: 'normal',
  },
  dataRight: {
    textAlign: 'right',
    alignSelf: 'flex-end',
  },
  teaser: {
    color: theme.palette.xpl.text.primary,
    fontSize: '16px',
  },
});

const nextPayDateFormat = 'dddd MMMM Do YYYY';

const UpcomingPaymentPreview = (props) => {
  const { classes, customerDetails, localisation, permissions } = props;
  const { adfitNo, billNext, payMethod, nextPaymentAmount } = customerDetails;
  const nextPayDate =
    payMethod && billNext && moment(billNext).format(nextPayDateFormat);
  const paymentType =
    payMethod && localisation.prompts.accountType[payMethod.accountType];
  const accountNo = payMethod && payMethod.accountNo;

  const paymentAvailable =
    payMethod && payMethod.found && adfitNo && nextPaymentAmount != null;

  const title = paymentAvailable ? 'Upcoming Payments' : 'No Upcoming Payments';
  const pmtDate = paymentAvailable
    ? `${nextPayDate} by ${paymentType} ending with ${accountNo}`
    : 'No payment method was found.';
  const pmtTeaser = paymentAvailable
    ? 'Next payment'
    : 'Information on next payment unavailable';
  const pmtAmount = paymentAvailable
    ? `${numberToCurrency(nextPaymentAmount || 0, localisation)}`
    : '';
  return (
    <InfoWidget
      title={`${title}`}
      actionButton={
        payMethod &&
        payMethod.exists &&
        (permissions.includes('IsAdmin') ||
          (permissions.includes('CanManageVariations') &&
            (permissions.includes('CanAddPaymentAtBusiness') ||
              (permissions.includes('CanAddPaymentAtBusiness') &&
                permissions.includes('CanReversePaymentAtBusiness'))))) && (
          <RouterLink to={`/Customers/${adfitNo}/Variations`}>
            <OutlinedButton>{'Pay at Business'} </OutlinedButton>
          </RouterLink>
        )
      }
      isLoading={!payMethod}
      contentLoader={<UpcomingPaymentsLoader />}>
      <Grid
        container
        className={classes.root}
        direction="row"
        justify="space-between">
        <Grid item>
          <Typography className={classes.teaser}>{`${pmtTeaser}`}</Typography>
          <Typography
            variant="h6"
            className={classes.dateText}>{`${pmtDate}`}</Typography>
        </Grid>
        <Grid item className={classes.dataRight}>
          <Typography variant="h4">{`${pmtAmount}`}</Typography>
        </Grid>
      </Grid>
    </InfoWidget>
  );
};

UpcomingPaymentPreview.propTypes = {
  classes: PropTypes.object.isRequired,
  customerDetails: PropTypes.object,
  localisation: PropTypes.object,
  permissions: PropTypes.array.isRequired,
};

export default withStyles(styles)(UpcomingPaymentPreview);
